module.exports = __webpack_public_path__ + "img/600803.7192a5e7.jpg";